export default {
    after_scanning_qr: "qr кодун сканерлегенден кийин",
    application_reason: "Кайрылуунун себеби",
    are_you_sure_you_want_to_delete_lead: "Сиз чындыгында өтүнмөнү жокко чыгаргыңыз келеби?",
    check_status: "Статусту текшерүү",
    click_here: "бул жерди басыңыз",
    connect: "Туташтыруу",
    connection_is_right_can_be_used: "Туташуу туура - колдонсо болот",
    'crm-form': "CRM-форма",
    forms: "Формалар",
    lead: "Өтүнмө",
    leads: "Өтүнмөлөр",
    not_reached: "Байланыша алган жокпуз",
    site_form: "Форма",
    stale: "Өтүмсүз",
    telegram: "Telegram",
    telegram_qr_instructions: "Телефонуңуздун телеграмм жөндөөлөрүнөн QR кодун окуңуз",
    thinking: "Ойлонууда",
    unpaid_message: "Сиздин эсебиңизде кеч төлөм бар. Сураныч, балансыңызды толуктаңыз же техникалык колдоо менен байланышыңыз.",
    urgent: "Шашылыш",
    whatsapp: "Whatsapp",
    whatsapp_qr_instructions: "Телефонуңузда WhatsApp жөндөөлөрүнөн 'түзмөктү байланыштырууну' тандап, qr кодун сканерлеңиз"
}
